import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('schedule', {
    components: {
        datePicker
    },

    props: ['user'],

    data () {
        return {
            tpOptions: {
                format: 'HH:mm',
            },

            loading: false,

            createForm: $.extend(true, new Form({
                data: {
                    start: '',
                    finish: '',
                    day: '',
                    client: '',
                    target: 25,
                    week: ''
                }
            }), {}),

            editForm: $.extend(true, new Form({
                data: {
                    id: '',
                    start: '',
                    finish: '',
                    day: '',
                    client: '',
                    target: 25,
                    week: ''
                }
            }), {}),

            cloneForm: $.extend(true, new Form({
                data: {
                    from_week: '',
                    to_week: '',
                }
            }), {}),

            schedule: []
        };
    },

    mounted () {
        this.getSchedule();
    },

    methods: {
        createForUser (week) {
            this.createForm.data.week = week;

            $('#schedule-create').modal('show');
        },

        cloneSchedule (cloneFromWeek) {
            this.cloneForm.data.from_week = cloneFromWeek;

            $('#schedule-clone').modal('show');
        },

        clone () {
            this.loading = true;

            axios.post('/api/schedule/clone', this.cloneForm, {
                params: {
                    user: this.user
                }
            }).then(() => {
                this.getSchedule();

                $('#schedule-clone').modal('hide');
            });
        },

        getSchedule () {
            this.loading = true;

            axios.get('/api/schedule', {
                params: {
                    user: this.user
                }
            }).then((response) => {
                this.loading = false;

                this.schedule = response.data;
            });
        },

        create () {
            Http.post('/api/schedule/create', this.createForm, {
                params: {
                    user: this.user
                }
            }).then((response) => {
                this.getSchedule();

                this.createForm.resetForm();

                $('#schedule-create').modal('hide');
            });
        },

        edit (item) {
            this.editForm.data.id = item.id;
            this.editForm.data.start = item.start;
            this.editForm.data.finish = item.finish;
            this.editForm.data.day = item.day;
            this.editForm.data.client = item.client_id;
            this.editForm.data.target = item.target;
            this.editForm.data.week = item.week;

            $('#schedule-edit').modal('show');
        },

        update () {
            Http.post('/api/schedule/update', this.editForm).then((response) => {
                this.getSchedule();

                this.editForm.resetForm();

                $('#schedule-edit').modal('hide');
            });
        },

        deleteSchedule(id) {
            this.id = id;

            $('#schedule-delete').modal('show');
        },

        doDeleteSchedule() {
            axios.post('/api/schedule/delete', {
                id: this.id
            }).then((response) => {
                this.getSchedule();

                $('#schedule-delete').modal('hide');
            });
        }
    }
});
